import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  DxButtonComponent,
  DxCheckBoxComponent,
  DxDataGridComponent,
  DxLoadPanelComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { MansioniService } from 'src/app/shared/services/mansioni.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { RepartiService } from 'src/app/shared/services/reparti.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { confirm } from 'devextreme/ui/dialog';
import { ProposteGestioneService } from 'src/app/shared/services/proposte-gestione.service';
import { PopupSostituisciArticoloComponent } from 'src/app/shared/components/popups/popup-sostituisci-articolo/popup-sostituisci-articolo.component';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoSelectionComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-proposte-gestione',
  templateUrl: './proposte-gestione.component.html',
  styleUrls: ['./proposte-gestione.component.scss'],
  imports: [
    DxDataGridComponent,
    DxTemplateDirective,
    DxCheckBoxComponent,
    DxLoadPanelComponent,
    DxButtonComponent,
    PopupSostituisciArticoloComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoSelectionComponent,
    DxiColumnComponent,
    DxoLookupComponent,
  ],
  standalone: true,
})
export class ProposteGestioneComponent implements OnInit {
  private dipService = inject(DipendentiService);
  private tipiArtService = inject(TipiArticoliService);
  private artService = inject(ArticoliService);
  private propService = inject(ProposteGestioneService);
  private mansioniService = inject(MansioniService);
  private repartiService = inject(RepartiService);
  private nS = inject(NavigatorService);
  @ViewChild('grid', { static: false }) dataGridProposte: DxDataGridComponent;
  dataSource: any;
  filterValue: any = true;
  listTipiArticoli: any;
  listDipendenti: any;
  listReparti: any;
  listMansioni: any;
  listArticoli: any;
  listTipoProposta = JSON.parse(
    '[{"codice":"C", "descrizione":"Consegna"},{"codice":"R", "descrizione":"Ritiro"}, {"codice":"P", "descrizione":"Articolo Previsto"}, {"codice":"N", "descrizione":"Nuovo Articolo"} , {"codice":"O", "descrizione":"Articolo Obsoleto"},{"codice":"D", "descrizione":"Agg. dipendente"},{"codice":"I", "descrizione":"Import dispenser"}]',
  );

  filterNonVisti = true;

  loadPanelVisible = false;

  idArticoloDaSostituire = 0;
  showPopupSostituisciArticolo = false;

  loadLookups() {
    this.repartiService.listTemp().subscribe({
      next: (res) => {
        this.listReparti = res;
      }
    });

    this.dipService.listTemp().subscribe({
      next: (res) => {
        this.listDipendenti = res;
      }
    });

    this.mansioniService.list().subscribe({
      next: (res) => {
        this.listMansioni = res;
      },
      error: (error) => {
        console.error('Errore caricamento mansioni: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento mansioni', 'warning');
        }
      },
    });

    this.artService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = res;
      },
      error: (error) => {
        console.error('Errore caricamento articoli: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento articoli', 'warning');
        }
      },
    });

    this.tipiArtService.list().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (error) => {
        console.error('Errore caricamento tipi articoli: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'warning');
        }
      },
    });
  }

  ngOnInit() {
    this.loadLookups();
    this.loadDataSource();
  }

  onFilterNonVistiChanged() {
    this.loadDataSource();
  }

  loadDataSource() {
    let call = this.propService.list();
    if (this.filterNonVisti) {
      call = this.propService.listNonViste();
    }

    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(call)
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
    });
  }

  getRepartoDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.sito?.descrizione?.length > 0
        ? ' (' + item.sito.descrizione + ')'
        : '')
    );
  }

  getMansioneDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.descrizione;
  }

  getDipendenteDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.nominativo;
  }

  getArticoloDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.descrizione;
  }

  onBtnSegnaVistiClick() {
    const righeSelezionate =
      this.dataGridProposte.instance.getSelectedRowKeys();
    if (righeSelezionate.length == 0) {
      notify('Nessuna riga è stata selezionata', 'warning', 3000);
    } else if (righeSelezionate.length > 0) {
      this.loadPanelVisible = true;
      const selection = new Object();
      selection['idsList'] = righeSelezionate;
      this.propService.setViste(selection).subscribe({
        next: () => {
          this.loadPanelVisible = false;
          this.loadDataSource();
        },
        error: (error) => {
          this.loadPanelVisible = false;
          console.error('Errore set viste: ' + error);
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore set viste', 'warning');
          }
        },
      });
    }
  }

  doConfermaRitiro(rowData) {
    const result = confirm(
      '<i>La proposta di ritiro viene considerata come gestita?</i>',
      'Conferma',
    );
    result.then((dialogResult) => {
      if (dialogResult) {
        rowData.gestita = true;
        rowData.visto = true;
        this.loadPanelVisible = true;
        this.propService.update(rowData.id, rowData).subscribe({
          next: () => {
            this.loadPanelVisible = false;
            notify('Ritiro gestito', 'success');
            this.loadDataSource();
          },
          error: (error) => {
            this.loadPanelVisible = false;
            console.error('Errore gestione ritiro: ' + error);
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore gestione ritiro', 'warning');
            }
          },
        });
      }
    });
  }

  doAggiornaModello(rowData) {
    rowData.visto = true;
    this.loadPanelVisible = true;
    this.propService.update(rowData.id, rowData).subscribe({
      next: () => {
        this.loadPanelVisible = false;
        this.nS.goToDipendentiDetailTab(
          rowData.idDipendente,
          'dettaglio-articoli',
        );
      },
      error: (error) => {
        this.loadPanelVisible = false;
        console.error('Errore gestione proposta: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore gestione proposta', 'warning');
        }
      },
    });
  }

  doConsegnaArticolo(rowData) {
    rowData.visto = true;
    this.loadPanelVisible = true;
    this.propService.update(rowData.id, rowData).subscribe({
      next: () => {
        this.loadPanelVisible = false;
        this.nS.goToNuovaConsegnaDipendente(rowData.idDipendente);
      },
      error: (error) => {
        this.loadPanelVisible = false;
        console.error('Errore gestione proposta: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore gestione proposta', 'warning');
        }
      },
    });
  }

  doCompletaNuovoArticolo(rowData) {
    rowData.visto = true;
    this.loadPanelVisible = true;
    this.propService.update(rowData.id, rowData).subscribe({
      next: () => {
        this.loadPanelVisible = false;
        this.nS.goToArticoloDetail(rowData.idArticolo);
      },
      error: (error) => {
        this.loadPanelVisible = false;
        console.error('Errore gestione proposta: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore gestione proposta', 'warning');
        }
      },
    });
  }

  doVerificaDatiDipendente(rowData) {
    rowData.visto = true;
    this.loadPanelVisible = true;
    this.propService.update(rowData.id, rowData).subscribe({
      next: () => {
        this.loadPanelVisible = false;
        this.nS.goToDipendentiDetail(rowData.idDipendente);
      },
      error: (error) => {
        this.loadPanelVisible = false;
        console.error('Errore gestione proposta: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore gestione proposta', 'warning');
        }
      },
    });
  }

  doSostituisciArticoloObsoleto(rowData) {
    this.idArticoloDaSostituire = rowData.idArticolo;
    this.showPopupSostituisciArticolo = true;
  }

  onPopupSostituisciArticoloEvent(e) {
    this.idArticoloDaSostituire = 0;
    this.showPopupSostituisciArticolo = false;
    if (e) {
      this.loadDataSource();
    }
  }

  doMarcaObsoletoFatto(rowData) {
    const result = confirm(
      '<i>La proposta di articolo da sostituire viene considerata come gestita?</i>',
      'Conferma',
    );
    result.then((dialogResult) => {
      if (dialogResult) {
        rowData.gestita = true;
        rowData.visto = true;
        this.loadPanelVisible = true;
        this.propService.update(rowData.id, rowData).subscribe({
          next: () => {
            this.loadPanelVisible = false;
            notify('Articolo obsoleto gestito', 'success');
            this.loadDataSource();
          },
          error: (error) => {
            this.loadPanelVisible = false;
            console.error('Errore gestione articolo obsoleto: ' + error);
            if (error?.status == 500 && error?.error?.title) {
              notify(error?.error?.title, 'warning');
            } else {
              notify('Errore gestione articolo obsoleto', 'warning');
            }
          },
        });
      }
    });
  }
}
